import moment from "moment";
import http from "./httpService";
import { getJwt } from "./authService";
import { getReportingParams } from "./eventSelectionService";

http.setJwt(getJwt()!);

export const postEvent = async ({
  eventId,
  severity,
  eventDetailsDate,
}: {
  eventId: string;
  severity?: string;
  eventDetailsDate?: string;
}) => {
  const params = getReportingParams();
  params.period = moment(params.period).format("YYYY-MM-DD") as any;
  const eventDate = moment(eventDetailsDate || params.period).format(
    "YYYY-MM-DD"
  ) as any;
  let status = "Closed";
  switch (params.event) {
    case "Incidents":
    case "Other safety events":
    case "Health event":
      if (severity) {
        const severityLevel = Number(severity);
        if (severityLevel >= 3) {
          status = "Need Validation";
          console.log("Setting status to Need Validation for severity:", severityLevel);
        } else {
          console.log("Setting status to Closed for severity:", severityLevel);
        }
      }
  }
  const url = `${process.env.REACT_APP_API_URL}/reportings`;
  const { data } = await http.post(url, {
    eventId,
    status,
    eventDate,
    securityLevel: severity || null,
    ...params,
  });
  return data;
};

export default postEvent;
